import React from "react";
import NavbarOne from "./separate/NavbarOne";
import soon from "../assets/images/comingsoon.png";
import "../assets/styledev.css";

export default function ComingSoon(props) {
  return (
    <div className="coming-wrapper min-vh-100 bg-default ">
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />

      <div className="coming-container container py-3">
        <div className="content">
          <p className="badge">🚀 Upcoming Feature</p>

          <h1 className="title">
            We’re Building <br />
            <span>Something Powerful</span>
          </h1>

          <p className="subtitle">
            Our team is crafting a next-generation experience focused on
            performance, security, and seamless usability. Stay tuned.
          </p>

          <button
            className="home-btn"
            onClick={() => (window.location.href = "/")}
          >
            ← Back to Home
          </button>
        </div>

        <div className="image-section">
          <img src={soon} alt="coming soon" className="floating-img" />
        </div>
      </div>
    </div>
  );
}